import React from 'react';
import { ConfigContainer } from '../common/style/Common.style';
import SplioConfigCreateForm from './SplioConfigCreateForm/SplioConfigCreateForm';
import SplioConfigUpdateForm from './SplioConfigUpdateForm/SplioConfigUpdateForm';
import { PanelTitle, PanelText, ConfigWrapper, SuccessMessage } from './SplioLoyaltyIntegration.style';
import Modal from '@/components/atoms/Modal';
import { ActionBar } from '@/components/atoms/ActionBar';
import { Button } from '@/components/atoms/Button';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import useCreateSplioConfig from './SplioConfigCreateForm/useCreateSplioConfig';
import useUpdateSplioConfig from './SplioConfigUpdateForm/useUpdateSplioConfig';
import useSplioLoyaltyIntegrationVM from './SplioLoyaltyIntegrationVM';
import Loader from '@/components/atoms/Loader';
const SplioLoyaltyIntegration = () => {
    const { restaurantId } = useParams<{ restaurantId: string; brandId: string }>();
    const {
        hasSplioConfig,
        loyaltyConfig,
        loyaltyPrograms,
        isLoading,
        isDeleting,
        isModalOpen,
        setIsModalOpen,
        deleteConfig,
        isLoadingLoyaltyPrograms,
    } = useSplioLoyaltyIntegrationVM();
    const { onSubmit, control, handleSubmit, isCreating, isDirty: isCreateDirty } = useCreateSplioConfig();
    const {
        onSubmit: onUpdateSubmit,
        control: updateControl,
        handleSubmit: updateHandleSubmit,
        isUpdating,
        isDirty: isUpdateDirty,
        isValid: isUpdateValid,
        isUpdateSuccess,
    } = useUpdateSplioConfig();

    const handleSave = () => {
        if (hasSplioConfig) {
            updateHandleSubmit(onUpdateSubmit)();
        } else {
            handleSubmit(onSubmit)();
        }
    };
    return (
        <ConfigWrapper>
            <ConfigContainer>
                <div>
                    <PanelTitle text="splio.title" />
                    <PanelText text="splio.description" />
                </div>
                <div>
                    {isLoading ? (
                        <Loader withContainer />
                    ) : !hasSplioConfig ? (
                        <SplioConfigCreateForm
                            control={control}
                            canChangeProvider={!loyaltyConfig?.provider || loyaltyConfig?.provider === 'splio'}
                        />
                    ) : isLoadingLoyaltyPrograms && loyaltyPrograms ? (
                        <div>Loading...</div>
                    ) : (
                        <SplioConfigUpdateForm
                            control={updateControl}
                            loyaltyPrograms={loyaltyPrograms}
                            loyaltyConfig={loyaltyConfig}
                        />
                    )}
                </div>
            </ConfigContainer>
            <Modal
                isOpen={isModalOpen}
                title="splio.deleteModal.title"
                onHide={() => setIsModalOpen(false)}
                width={500}
                buttons={[
                    <Button
                        buttonType="red"
                        onClick={() => {
                            deleteConfig({ restaurantId: Number(restaurantId) });
                            setIsModalOpen(false);
                        }}
                        isLoading={isDeleting}
                    >
                        <FormattedMessage id="button.delete" />
                    </Button>,
                ]}
            >
                <p>
                    <FormattedMessage id="splio.deleteModal.text" />
                </p>
            </Modal>
            <ActionBar>
                {isUpdateSuccess && (
                    <SuccessMessage>
                        <FormattedMessage id="splio.update.success" />
                    </SuccessMessage>
                )}
                {hasSplioConfig && (
                    <Button buttonType="red" onClick={() => setIsModalOpen(true)} isLoading={isDeleting}>
                        <FormattedMessage id="button.delete" />
                    </Button>
                )}

                <Button
                    buttonType="primary"
                    disabled={!((isUpdateDirty && isUpdateValid) || isCreateDirty)}
                    onClick={handleSave}
                    isLoading={isCreating || isUpdating}
                >
                    <FormattedMessage id="button.save" />
                </Button>
            </ActionBar>
        </ConfigWrapper>
    );
};

export default SplioLoyaltyIntegration;
